import type { FieldConstraints } from '@campaign-manager/core/infra/api-middleware/createNormalizingProxy';

/**
 * Auto-generated constraints for CustomPlacementRequest.
 * DO NOT EDIT - regenerate with: bun scripts/generate-constraints.ts
 */
export const customPlacementRequestConstraints: FieldConstraints = {
  "properties": {
    "name": {
      "maxLength": 64,
      "minLength": 3
    },
    "allowed_billings": {
      "maxItems": 4,
      "nullable": true,
      "items": {
        "properties": {
          "min_bid_in_cents": {
            "nullable": true
          },
          "category_billings": {
            "nullable": true,
            "items": {
              "properties": {
                "inherited": {
                  "nullable": true
                }
              }
            }
          }
        }
      }
    },
    "catalog_key": {
      "maxLength": 36,
      "nullable": true
    },
    "allowed_advertiser_ids": {
      "maxItems": 10,
      "minItems": 1,
      "uniqueItems": true,
      "nullable": true
    },
    "max_headline_length": {
      "nullable": true
    },
    "has_discounts": {
      "nullable": true
    },
    "has_keywords": {
      "nullable": true
    },
    "has_audience": {
      "nullable": true
    },
    "has_geo": {
      "nullable": true
    },
    "has_dayparting": {
      "nullable": true
    },
    "has_stores": {
      "nullable": true
    },
    "has_skus": {
      "nullable": true
    },
    "has_advertised_skus": {
      "nullable": true
    },
    "has_link_url": {
      "nullable": true
    },
    "category_targeting_mode": {
      "nullable": true
    },
    "creatives": {
      "nullable": true
    },
    "description": {
      "maxLength": 255,
      "nullable": true
    },
    "image_url": {
      "maxLength": 255,
      "nullable": true
    },
    "weight_bid": {
      "nullable": true
    },
    "weight_relevance": {
      "nullable": true
    },
    "group": {
      "maxLength": 64,
      "minLength": 1,
      "nullable": true
    },
    "attribution": {
      "nullable": true,
      "properties": {
        "post_click": {
          "nullable": true
        },
        "post_view": {
          "nullable": true
        }
      }
    },
    "custom_targeting": {
      "nullable": true
    },
    "advanced_settings": {
      "nullable": true,
      "properties": {
        "allow_pacing": {
          "nullable": true
        },
        "show_inventory": {
          "nullable": true
        },
        "serve_skus": {
          "nullable": true
        },
        "auto_keyword_skus_match": {
          "nullable": true
        },
        "disable_ad_cache": {
          "nullable": true
        },
        "auto_bidding": {
          "nullable": true
        },
        "allow_frequency_capping": {
          "nullable": true
        },
        "forecasting_mode": {
          "nullable": true
        },
        "bill_per_sku": {
          "nullable": true
        }
      }
    },
    "guidelines": {
      "nullable": true,
      "properties": {
        "keywords": {
          "maxLength": 1024,
          "nullable": true
        },
        "creatives": {
          "maxLength": 1024,
          "nullable": true
        }
      }
    },
    "preview_templates": {
      "nullable": true
    },
    "requires_approval": {
      "maxItems": 13,
      "uniqueItems": true
    }
  }
};
